export default __webpack_public_path__ + "static/media/quantisal_step1.39cfedec.png";